// src/pages/preAccounting/components/DealerPreAccountingTable.jsx
import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const DealerPreAccountingTable = ({
  th,
  data,
  totalRecords,
  lazyParams,
  onPage,
  onSort,
  loading,
  onEdit,
}) => {
  const dateBody = (val) => (val ? new Date(val).toLocaleDateString('tr-TR') : '');
  const amountBody = (row) =>
    row?.amount != null ? Number(row.amount).toLocaleString(navigator.language, {
        minimumFractionDigits: 0,
      })
    : '';

const runningBalanceBody = (row) =>
  row?.runningBalance != null
    ? Number(row.runningBalance).toLocaleString(navigator.language, {
        minimumFractionDigits: 0,
      })
    : '';

  const actionBodyTemplate = (rowData) => {
    if (!rowData.isManuel) return null;
    return (
      <div className="flex justify-content-center">
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text p-button-sm"
          onClick={() => onEdit?.(rowData)}
          tooltip={th('common.edit')}
          tooltipOptions={{ position: 'top' }}
        />
      </div>
    );
  };

  return (
    <DataTable
      value={data}
      lazy
      paginator
      first={lazyParams.first}
      rows={lazyParams.rows}
      totalRecords={totalRecords}
      onPage={onPage}
      onSort={onSort}
      sortField={lazyParams.sortField}
      sortOrder={lazyParams.sortOrder}
      className="p-datatable-gridlines"
      showGridlines
      dataKey="id"
      loading={loading}
      rowsPerPageOptions={[5, 10, 25, 50]}
      tableStyle={{ minWidth: '64rem' }}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate={th('table.paginatorTemplate')}
      emptyMessage={th('common.noRecords')}
    >
      {/* <Column body={actionBodyTemplate} exportable={false} style={{ width: '5%', minWidth: '60px' }} frozen /> */}
      <Column field="paymentType" header={th('preAccounting.paymentType')} sortable style={{ width: '12%' }} />
      <Column field="transactionType" header={th('preAccounting.transactionType')} sortable style={{ width: '12%' }} />
      <Column field="processType" header={th('preAccounting.processType')} sortable style={{ width: '10%' }} />
      <Column
        field="transactionDate"
        header={th('preAccounting.transactionDate')}
        sortable
        body={(row) => dateBody(row.transactionDate)}
        style={{ width: '11%' }}
      />
      <Column
        field="dueDate"
        header={th('preAccounting.dueDate')}
        sortable
        body={(row) => dateBody(row.dueDate)}
        style={{ width: '11%' }}
      />
      <Column field="currency" header={th('preAccounting.currency')} sortable style={{ width: '7%' }} />
      <Column
        field="amount"
        header={th('preAccounting.amount')}
        sortable
        body={amountBody}
        style={{ width: '10%', textAlign: 'right' }}
      />
      <Column
        field="runningBalance"
        header={th('preAccounting.runningBalance')}
        sortable
        body={runningBalanceBody}
        style={{ width: '10%', textAlign: 'right' }}
      />
      <Column field="documentSeriesNo" header={th('preAccounting.documentSeriesNo')} sortable style={{ width: '10%' }} />
      <Column field="documentNo" header={th('preAccounting.documentNo')} sortable style={{ width: '8%' }} />
      <Column field="description" header={th('preAccounting.description')} sortable style={{ width: '17%' }} />
      <Column field="createdUser" header={th('customerAddressBrand.createdBy')} sortable style={{ width: '17%' }} />
    </DataTable>
  );
};

export default DealerPreAccountingTable;
